import { yupResolver } from "@hookform/resolvers/yup";
import {
  Alert,
  Button,
  FormControlLabel,
  Grid,
  Switch,
  TextField,
} from "@mui/material";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { PackageTypesProps } from "../../../../../types/packageType";

let customRegimeScheme = yup.object({
  CODIGO_SAP_EDI: yup.string().max(5).required(),
  DSC_TIPO_PACKAGE: yup.string().max(50).required(),
  ATIVO: yup.boolean().notRequired(),
});

interface CargoProps {
  packageType: PackageTypesProps;
  onSubmit: (customRegime: PackageTypesProps) => void;
  onCancel: () => void;
  isLoading?: boolean;
  errors?: string[];
  controlEdit: {
    loading: boolean;
    isInUse: boolean;
  };
  readOnly?: boolean
}

export default function CargoTreatment({
  packageType,
  onSubmit,
  onCancel,
  isLoading = false,
  errors = [],
  controlEdit,
  readOnly
}: CargoProps) {
  const {
    register,
    handleSubmit,
    formState: { errors: formErrors },
    control,
    reset,
  } = useForm({
    resolver: yupResolver(customRegimeScheme),
  });

  useEffect(() => {
    reset(packageType);
  }, [packageType, reset]);

  const handleFormSubmit = (packageTypesProps: PackageTypesProps) => {
    onSubmit(packageTypesProps);
  };

  const handleCancel = () => {
    reset({ CODIGO_SAP_EDI: "", DSC_TIPO_PACKAGE: "" });
    onCancel();
  };

  return (
    <form
      style={{ width: "100%" }}
      onSubmit={handleSubmit(handleFormSubmit as any)}
      data-testid="customRegime-form"
    >
      {errors.map((error) => (
        <Alert key={error} severity="error" style={{ marginBottom: 20 }}>
          {error}
        </Alert>
      ))}
      <Grid
        data-testid="search"
        container
        spacing={2}
        marginTop={1}
        border={1}
        padding={2}
        borderColor={"#7b7b7b"}
        borderRadius={2}
        alignItems="center"
      >
        <Grid marginBottom={5} container justifyContent="flex-end" spacing={2}>
          <Grid item xs={3}>
            <Controller
              control={control}
              render={({ field: { value } }) => (
                <TextField
                  fullWidth
                  type="text"
                  label="Description"
                  size="small"
                  variant="outlined"
                  disabled={controlEdit.isInUse || readOnly}
                  defaultValue={value}
                  error={!!formErrors.DSC_TIPO_PACKAGE}
                  InputLabelProps={{ shrink: !!value }}
                  {...register("DSC_TIPO_PACKAGE")}
                  inputProps={{ maxLength: 50, 'data-testid': 'DSC_TIPO_PACKAGE-input' }}
                />
              )}
              name="DSC_TIPO_PACKAGE"
            />
          </Grid>
          <Grid item xs={6}>
            <Controller
              control={control}
              render={({ field: { value } }) => (
                <TextField
                  fullWidth
                  type="text"
                  label="Sap Code"
                  size="small"
                  variant="outlined"
                  disabled={controlEdit.isInUse || readOnly}
                  defaultValue={value}
                  error={!!formErrors.CODIGO_SAP_EDI}
                  InputLabelProps={{ shrink: !!value }}
                  {...register("CODIGO_SAP_EDI")}
                  inputProps={{ maxLength: 5, 'data-testid': 'CODIGO_SAP_EDI-input' }}
                />
              )}
              name="CODIGO_SAP_EDI"
            />
          </Grid>
          <Grid item xs={3}>
            <Controller
              render={({ field: { value } }) => (
                <FormControlLabel
                  control={
                    <Switch
                      checked={!!value}
                      disabled={readOnly}
                      inputProps={{ "aria-label": "controlled" }}
                      {...register("ATIVO")}
                    />
                  }
                  labelPlacement="start"
                  label="Status"
                />
              )}
              name="ATIVO"
              control={control}
            />
          </Grid>
          <Grid item xs={12}></Grid>
        </Grid>
        <Grid container justifyContent="flex-end" spacing={2}>
          <Grid>
            <Button
              variant="outlined"
              onClick={handleCancel}
              disabled={isLoading}
              data-testid="cancel-button"
            >
              Cancel
            </Button>
          </Grid>
          {!readOnly ? (
              <Grid marginLeft={2}>
                <Button
                    variant="contained"
                    disabled={isLoading}
                    type="submit"
                    data-testid="submit-button"
                >
                  Confirm
                </Button>
              </Grid>
          ) : null }
        </Grid>
      </Grid>
    </form>
  );
}
